
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqData = [
    { question: t('common:faq.q1'), answer: t('common:faq.a1') },
    { question: t('common:faq.q2'), answer: t('common:faq.a2') },
    { question: t('common:faq.q3'), answer: t('common:faq.a3') },
    { question: t('common:faq.q4'), answer: t('common:faq.a4') },
    { question: t('common:faq.q5'), answer: t('common:faq.a5') },
    { question: t('common:faq.q6'), answer: t('common:faq.a6') },
    { question: t('common:faq.q7'), answer: t('common:faq.a7') },
    { question: t('common:faq.q8'), answer: t('common:faq.a8') },
    { question: t('common:faq.q9'), answer: t('common:faq.a9') },
    { question: t('common:faq.q10'), answer: t('common:faq.a10') },
  ];

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-gradient-to-b from-white to-[#F5F1E8]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#8B4513] mb-4">
            {t('common:faq.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('common:faq.subtitle')}
          </p>
        </div>

        <div className="space-y-4">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md border border-[#B8860B]/20 overflow-hidden transition-all duration-300 hover:shadow-lg"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-[#F5F1E8]/30 transition-colors duration-200 cursor-pointer"
              >
                <h3 className="text-lg md:text-xl font-semibold text-[#8B4513] pr-4">
                  {faq.question}
                </h3>
                <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                  <i
                    className={`ri-arrow-down-s-line text-2xl text-[#B8860B] transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5 pt-2">
                  <p className="text-base text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-lg text-gray-700 mb-6">
            {t('common:faq.ctaText')}
          </p>
          <a
            href="/tokyo-airbnb-support#contact"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-[#14B8A6] to-[#0D9488] text-white text-lg font-semibold rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {t('common:faq.ctaButton')}
            <i className="ri-arrow-right-line ml-2 text-xl"></i>
          </a>
        </div>
      </div>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqData.map((faq) => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>
    </section>
  );
}
